export const DAISY_THEMES = [
  'light',
  'dark',
  'cupcake',
  'bumblebee',
  'emerald',
  'corporate',
  'synthwave',
  'retro',
  'cyberpunk',
  'valentine',
  'halloween',
  'garden',
  'forest',
  'aqua',
  'lofi',
  'pastel',
  'fantasy',
  'wireframe',
  'black',
  'luxury',
  'dracula',
  'cmyk',
  'autumn',
  'business',
  'acid',
  'lemonade',
  'night',
  'coffee',
  'winter',
  'dim',
  'nord',
  'sunset',
  'caramellatte',
  'abyss',
  'silk',
] as const

export type DaisyTheme = (typeof DAISY_THEMES)[number]

// Themes whose --color-base-100 is a dark background (daisyUI v5 classification)
export const DAISY_DARK_THEMES: readonly DaisyTheme[] = [
  'dark',
  'night',
  'dim',
  'dracula',
  'halloween',
  'luxury',
  'black',
  'coffee',
  'abyss',
  'synthwave',
  'cyberpunk',
  'forest',
  'aqua',
]

export function isDarkTheme(theme: string): theme is DaisyTheme {
  return DAISY_DARK_THEMES.includes(theme as DaisyTheme)
}

export function isValidTheme(theme: string): theme is DaisyTheme {
  return (DAISY_THEMES as readonly string[]).includes(theme)
}
